import { render, staticRenderFns } from "./compare-button.vue?vue&type=template&id=14c18813&lang=pug"
import script from "./compare-button.vue?vue&type=script&lang=coffee"
export * from "./compare-button.vue?vue&type=script&lang=coffee"
import style0 from "./compare-button.vue?vue&type=style&index=0&id=14c18813&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports